import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

const ControlledPasswordFieldStyles = makeStyles((theme: Theme) =>
    createStyles({
        ruleItem: {
            fontSize: '12px',
            color: theme.palette.grey[400],
            '& svg': {
                fontSize: '14px'
            }
        },
        ruleItemValid: {
            color: theme.palette.success.dark,
        },
    }),
);

export default ControlledPasswordFieldStyles;

